/*
 * use-event-listener
 */
import { useEffect, useRef } from "react"

export function useEventListener(
	eventName: string,
	handler: (event: any) => void,
	element?: Window | any,
): void {
	const savedHandler = useRef<any>(null)

	useEffect(() => {
		savedHandler.current = handler
	}, [handler])

	useEffect(() => {
		if (!element) {
			if (typeof window === "undefined") {
				return
			}
			element = window
		}
		const isSupported = element && element.addEventListener
		if (!isSupported) return

		const eventListener = (event: Event) => {
			savedHandler.current(event)
		}

		element.addEventListener(eventName, eventListener)

		return () => {
			element.removeEventListener(eventName, eventListener)
		}
	}, [eventName, element])
}
